import React, { ButtonHTMLAttributes } from "react";
import { CgCheck } from "react-icons/cg";

// import { Container } from './styles';

const CopyButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = (
  props,
) => {
  const [copied, setCopied] = React.useState(false);

  function clickAnim(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    if (props.onClick) props.onClick(e);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }

  return (
    <button {...props} onClick={clickAnim}>
      {copied ? (
        <div className="flex flex-1 items-center justify-center">
          <CgCheck size={24} />
        </div>
      ) : (
        props.children
      )}
    </button>
  );
};

export default CopyButton;
